import { useEffect, useState } from "react";
import api from "../api";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid
} from "recharts";

export default function SatStackerShowDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const range = "30d";

    useEffect(() => {
        setErr("");
        api.get(`/creator-dashboard/satstacker-show?range=${range}`)
            .then(res => setData(res.data))
            .catch(e => setErr(e?.response?.data?.detail || "Could not load dashboard"));
    }, []);

  if (err) return <div className="p-6 text-red-500">{err}</div>;
  if (!data) return <div className="p-6 text-zinc-300">Loading...</div>;

  const cards = [
    ["Signups", data.total_signups],
    ["Active subscribers", data.active_subscribers],
    ["Estimated monthly commission", `$${data.monthly_commission_usd}`],
    ["Clicks", data.clicks ?? 0],
    ["Installs", data.installs ?? 0],
  ];

  return (
    <div className="min-h-screen bg-zinc-950 text-white p-6">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold">SatStacker Show Dashboard</h1>
        <p className="text-zinc-400 mt-1">
          Performance for {data.media_source} / {data.campaign}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
          {cards.map(([label, value]) => (
            <div key={label} className="rounded-2xl border border-zinc-800 bg-zinc-900 p-5">
              <div className="text-sm text-zinc-400">{label}</div>
              <div className="text-3xl font-bold mt-2">{value}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-zinc-800 bg-zinc-900 p-5">
            <h2 className="text-lg font-semibold mb-4">Trend over time</h2>

            <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data.daily || []}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Line type="monotone" dataKey="clicks" strokeWidth={2} />
                    <Line type="monotone" dataKey="installs" strokeWidth={2} />
                    <Line type="monotone" dataKey="signups" strokeWidth={2} />
                    <Line type="monotone" dataKey="purchases" strokeWidth={2} />
                </LineChart>
                </ResponsiveContainer>
            </div>
        </div>  

        <p className="text-xs text-zinc-500 mt-6">
          Last updated: {new Date(data.last_updated).toLocaleString()}
        </p>
      </div>
    </div>
  );
}